/** Цвет стороны. */
export type Color = 'white' | 'black';

/**
 * Игровое поле — индекс тёмной клетки 0..31.
 * Ряд r (0 = ряд «1», снизу со стороны белых), в каждом ряду 4 тёмных поля.
 * Тёмные поля: (col + r) чётно, a=0. index = r*4 + floor(col/2).
 */
export type Square = number;

/** Содержимое клетки: 0 пусто, 1 белая простая, 2 белая дамка, 3 чёрная простая, 4 чёрная дамка. */
export const EMPTY = 0;
export const WM = 1;
export const WK = 2;
export const BM = 3;
export const BK = 4;
export type Cell = typeof EMPTY | typeof WM | typeof WK | typeof BM | typeof BK;

/**
 * Позиция. `board` — 32 клетки. `quiet` — число подряд идущих полуходов,
 * сделанных только дамками без взятий (для правила ничьи «15 ходов дамками»).
 */
export interface Position {
  board: Cell[];
  turn: Color;
  quiet: number;
}

/**
 * Ход — полная цепочка.
 * `from` — исходное поле; `path` — все точки остановки по порядку (для тихого хода одна);
 * `captured` — побитые поля в порядке взятия; `promoted` — стала ли простая дамкой этим ходом.
 */
export interface Move {
  from: Square;
  path: Square[];
  captured: Square[];
  promoted: boolean;
}

export type PositionKey = string;

export type GameStatus =
  | { state: 'playing' }
  | { state: 'win'; winner: Color; reason: 'no-pieces' | 'no-moves' }
  | { state: 'draw'; reason: 'repetition' | 'kings-15' | 'agreement' | 'timeout-no-material' };

export function colorOf(cell: Cell): Color | null {
  if (cell === WM || cell === WK) return 'white';
  if (cell === BM || cell === BK) return 'black';
  return null;
}

export function isKing(cell: Cell): boolean {
  return cell === WK || cell === BK;
}

export function opposite(c: Color): Color {
  return c === 'white' ? 'black' : 'white';
}
